export var Methods;
(function (Methods) {
    Methods["connectWallet"] = "connectWallet";
    Methods["switchNetwork"] = "switchNetwork";
    Methods["sign"] = "sign";
    Methods["contractCall"] = "contractCall";
    Methods["ethereumRequest"] = "ethereumRequest";
    Methods["getCurrentPkh"] = "getCurrentPkh";
    Methods["getPKP"] = "getPKP";
    Methods["executeLitAction"] = "executeLitAction";
    Methods["getDAppTable"] = "getDAppTable";
    Methods["getDAppInfo"] = "getDAppInfo";
    Methods["getValidAppCaps"] = "getValidAppCaps";
    Methods["getModelBaseInfo"] = "getModelBaseInfo";
    Methods["createCapability"] = "createCapability";
    Methods["checkCapability"] = "checkCapability";
    Methods["loadStream"] = "loadStream";
    Methods["loadStreamsBy"] = "loadStreamsBy";
    Methods["createStream"] = "createStream";
    Methods["updateStream"] = "updateStream";
    Methods["readFolders"] = "readFolders";
    Methods["createFolder"] = "createFolder";
    Methods["updateFolderBaseInfo"] = "updateFolderBaseInfo";
    Methods["changeFolderType"] = "changeFolderType";
    Methods["deleteFolder"] = "deleteFolder";
    Methods["monetizeFolder"] = "monetizeFolder";
    Methods["uploadFile"] = "uploadFile";
    Methods["updateFileBaseInfo"] = "updateFileBaseInfo";
    Methods["moveFiles"] = "moveFiles";
    Methods["removeFiles"] = "removeFiles";
    Methods["monetizeFile"] = "monetizeFile";
    Methods["createProfile"] = "createProfile";
    Methods["getProfiles"] = "getProfiles";
    Methods["unlock"] = "unlock";
    Methods["isCollected"] = "isCollected";
    Methods["getDatatokenBaseInfo"] = "getDatatokenBaseInfo";
})(Methods || (Methods = {}));
